import { useQuery } from "@tanstack/react-query";

import { dashboardService, type ModuleCard } from "./dashboardService";

/**
 * 租户**已开通**的业务模块(GET /me/modules;后端 MeService.moduleCards 按租户权益 listEnabled 出卡,
 * 平台超管非代客 → 空)。queryKey 与工作台 `useClusterCards` 同一份,命中同一缓存。
 *
 * ★为什么单独一个 hook(B1 契约 ③,0927):客服 / 陪练 module 门上线后,未开通的租户调舱内接口会
 *   403 MODULE_NOT_ENABLED —— 首页这类「顺手拉一下」的横幅要先看开通再请求,不能靠 permissions.modules
 *   的 localStorage 缓存(OEM H1 起会在加载 / 回焦 / 每 5 分钟刷新并与租户开通求交,但两次刷新之间仍可能陈旧)。
 */
export function useTenantModules() {
  return useQuery<ModuleCard[]>({
    queryKey: ["dashboard-modules"],
    queryFn: dashboardService.listModules,
    staleTime: 5 * 60_000,
    retry: false,
    meta: { suppressGlobalErrorToast: true },
  });
}

/**
 * 该模块租户是否已开通。**undefined = 还没拿到**(调用方别据此发请求);true / false = 含 / 不含
 * (卡带 status 且非 active 视为未开通,与 useClusterCards「status!=active 不上墙」同口径)。
 */
export function useTenantModuleEnabled(code: string): boolean | undefined {
  const q = useTenantModules();
  if (!q.data) return undefined;
  return q.data.some((m) => m.code === code && (m.status == null || m.status === "active"));
}
